import CouncellorHomepage from "./homepage/councellorshomepage";
import StudentHomepage from "./homepage/studentshomepage";
import TeachersHomepage from "./homepage/teachershomepage";
import StudentPage from "./students";
import SpecialNeedsCourses from "./students/specialneedscourses";
import StudentGameCentre from "./students/studentgamecentre";
import StudentsViewAll from "./students/studentscourses";
import VocationalCourses from "./students/vocationalcourses";
import Teacherspage from "./teachers/teacherspage";
import Profesionalpage from "./teachers/teachersprofesional"
import Productdetails from "./store/productdetails";
import Gandc from "./homepage/councellorshomepage/gandc";
import Store from "./store/store";
import Studentstore from "./store/generalstore";
import ShoppingCart from "./store/shoppingCart";
import Invoice from "./store/invoice/invoice";
import SavedProduct from "./store/saveproduct";
import { TourLagos } from "./TourLagos/TourLagos";
import { BeInstructor } from "./FooterPages/BeInstructor";
import { AboutUs } from "./FooterPages/AboutUs";
import { Faq } from "./FooterPages/faq/Faq";
import { TermsAndCondition } from "./FooterPages/TermsAndCondition";

export const app_routes = [
    { path: '/', Component: <StudentHomepage />, layout: false },
    { path: '/teachers', Component: <TeachersHomepage />, layout: false },
    { path: '/teachers-page', Component: <Teacherspage />, layout: false },
    { path: '/teachers-professional', Component: <Profesionalpage />, layout: false },
    // { path: '/teachers-dashboard', Component: <TeachersDashboard />, layout: false },
    { path: '/counsellors', Component: <CouncellorHomepage />, layout: false },
    { path: '/students-page', Component: <StudentPage />, layout: false },
    { path: '/students-view-all', Component: <StudentsViewAll />, layout: false },
    { path: '/students-vocational', Component: <VocationalCourses />, layout: false },
    { path: '/students-special-needs', Component: <SpecialNeedsCourses />, layout: false },
    { path: '/students-game-centre', Component: <StudentGameCentre />, layout: false },
    // { path: '/students-dashboard', Component: <StudentsDashboard />, layout: false },
    { path: '/guidance-counselling', Component: <Gandc />, layout: false },
    // store
    { path: '/store', Component: <Store />, layout: false },
    { path: '/saved-product', Component: <SavedProduct />, layout: false },
    { path: '/store/product', Component: <Studentstore />, layout: false },
    { path: '/product-details/:id', Component: <Productdetails />, layout: false },
    { path: '/shopping-cart', Component: <ShoppingCart />, layout: false },
    { path: '/invoice', Component: <Invoice />, layout: false },
    //Tour Lagos
    { path: '/tour', Component: <TourLagos />, layout: false },
    { path: '/be-instructor', Component: <BeInstructor />, layout: false },
    { path: '/about-us', Component: <AboutUs />, layout: false },
    { path: '/faq', Component: <Faq />, layout: false },
    { path: '/terms', Component: <TermsAndCondition />, layout: false },

]